module.exports = __webpack_public_path__ + "static/media/am.5758d3ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/am.svg
// module id = 48
// module chunks = 0